import { MenuItem } from "@bruisedears/app-lib";
import { menuData } from "./menu-data";

export const handsetBottomMenuData: MenuItem[] = [
    menuData.events, menuData.games, menuData.you, menuData.other
]